import React from "react";

function Admin() {
  return <div>asd</div>;
}

export default Admin;
